import { render, staticRenderFns } from "./grant-special-corse-work-submission-dialog.vue?vue&type=template&id=3698bdf6"
import script from "./grant-special-corse-work-submission-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./grant-special-corse-work-submission-dialog.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports